import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/fonts.css';
import './index.css';
import './utils.css';
import App from './App';
import {unregister as unregisterServiceWorker} from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js